import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-858527aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-bar"
}
const _hoisted_2 = { class: "main-bar__numbers" }
const _hoisted_3 = { class: "main-bar__icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main-bar__bubbles" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "main-bar__threshold main-bar__threshold--high"
}
const _hoisted_6 = {
  key: 1,
  class: "main-bar__threshold main-bar__threshold--medium"
}
const _hoisted_7 = {
  key: 2,
  class: "main-bar__threshold main-bar__threshold--light"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ManaIcon = _resolveComponent("ManaIcon")!

  return (_ctx.maxMana)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_ManaIcon)
          ]),
          _createElementVNode("h6", null, _toDisplayString(_ctx.characters[_ctx.current].mana.current) + " / " + _toDisplayString(_ctx.maxMana), 1)
        ]),
        _createElementVNode("div", {
          style: _normalizeStyle({ background: _ctx.bg }),
          class: "main-bar__bar"
        }, [
          _hoisted_4,
          (_ctx.percent > 10)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.percent > 25)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.percent > 50)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7))
            : _createCommentVNode("", true)
        ], 4)
      ]))
    : _createCommentVNode("", true)
}